// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmEmail_container__YsEm3"};